module.exports = __webpack_public_path__ + "img/ok.20b6e35b.png";